"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _bash = _interopRequireDefault(require("refractor/lang/bash.js"));

;
var _default = _bash["default"];
exports["default"] = _default;